import { datiTitolareBenefMorteEff } from './sezioni/sezioniAnagraficaTitolareEffBenefMorte';

export const titolareEffBenefMorte = {
  anagraficaValida: null,
  controlloDati: '',  
  datiTitolareBenefMorteEff: datiTitolareBenefMorteEff,
};